import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import formatByLabelFormat from './formatByLabelFormat';

const StyledTable = styled.table`
    th {
        font-weight: bold;
        background-color: #BBBBBB;
        padding: 3px 6px 3px 3px;
    }

    td {
        padding: 3px 6px 3px 3px;
    }

    tr:nth-child(2n) {
        background-color: #E6E6E6;
    }
`;

const MetricTable = ({ metric, metricData }) => {
    const { t: translate } = useTranslation();

    return (
        <StyledTable>
            <thead>
                <tr>
                    <th>{translate('common.abbr-year')}</th>
                    <th>{translate('common.abbr-level')}</th>
                    <th>{metric.Metric.StatName}</th>
                </tr>
            </thead>
            <tbody>
                {metricData.seasons.map((s) => (
                    <tr key={`${s.yearid}-${s.abbr}`}>
                        <td>{s.yearid}</td>
                        <td>{s.abbr}</td>
                        <td>{formatByLabelFormat(metric.Metric.LabelFormat, s.value)}</td>
                    </tr>

                )) }
                <tr>
                    <td>MLB</td>
                    <td>{translate('common.abbr-average')}</td>
                    <td>{formatByLabelFormat(metric.Metric.LabelFormat, metricData.leagueavg && metricData.leagueavg.length > 0 ? metricData.leagueavg[0].lvavgrate : null)}</td>
                </tr>
            </tbody>
        </StyledTable>
    );
};

export default MetricTable;
